<template>
  <a href="https://pubmatcher.fr/" target="_blank" rel="noopener noreferrer"
    class="group relative mx-auto mb-6 flex max-w-4xl items-center gap-4 overflow-hidden rounded-lg bg-blue-600 px-5 py-3 shadow-md transition-all hover:bg-blue-700 hover:shadow-lg dark:bg-blue-700 dark:hover:bg-blue-600">

    <!-- Icon -->
    <div class="flex-shrink-0">
      <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-white/20 text-white">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.847.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
        </svg>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-2">
        <span class="inline-flex items-center rounded-md bg-white/20 px-2 py-0.5 text-xs font-bold uppercase tracking-wider text-white">
          New
        </span>
        <span class="text-xs font-medium text-white/80">Beta · Faster · Sleeker</span>
      </div>
      <h3 class="mt-1 text-base font-bold text-white leading-tight">
        The next-generation PubMatcher is here
      </h3>
      <p class="text-xs text-white/80">
        Modern interface, snappier searches, and new features in active development.
      </p>
    </div>

    <!-- CTA -->
    <div class="flex-shrink-0">
      <span class="inline-flex items-center gap-1.5 rounded-md bg-white px-4 py-2 text-sm font-bold text-blue-700 transition-transform group-hover:translate-x-0.5">
        Try the beta
        <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
        </svg>
      </span>
    </div>
  </a>
</template>

<script setup>
</script>
